// extracted by mini-css-extract-plugin
module.exports = {"textStyles":"textStyles_textStyles__24S4N","auto-select-text":"textStyles_auto-select-text__FQKz7","section":"textStyles_section__3NK_v"};